import React from "react";
import { Box, Rating, Typography } from "@mui/material";

const CustomRatingInput = ({
  label,
  name,
  value = 0,
  onChange,
  error,
  helperText,
  max = 5,
  precision = 0.5,
  isLock,
  isReadOnly,
  disabled,
  ...rest
}) => {
  const isDisabled = isLock || disabled || isReadOnly;
  return (
    <Box sx={{ width: "100%", mt: 1 }}>
      <Rating
        name={name}
        value={Number(value) || 0}
        onChange={(e, val) => !isDisabled && onChange?.(val)}
        precision={precision}
        max={max}
        readOnly={isDisabled}
        {...rest}
      />
      {error && (
        <Typography variant="caption" color="error">
          {helperText}
        </Typography>
      )}
    </Box>
  );
};

export default CustomRatingInput;
